<script lang="ts">
	import { onMount } from 'svelte';
	import { format, locale } from 'svelte-i18n';
	import { mobile } from 'src/services/mobile-rework';
	import { save_profile } from 'src/helpers/profile_helpers';
	import { profile_data, user_data } from 'src/stores/account/user';
	import { navigateToUrl } from './Lists/list-helpers';
	import { capFirstChar } from 'src/helpers/utilities';

	// Components
	import { Container, Modal, Text } from '@Shelly/shelly-design-system';

	export let showModal = false;

	const onCloseAnnualSurveyModal = () => {
		if (showModal) {
			showModal = false;
			save_profile('promotions', {
				...$profile_data?.promotions,
				annualSurvey2026: new Date().getTime(),
			});
		}
	};

	onMount(() => {
		if (mobile.isMobile) {
			mobile.addEventListener('back_button', onCloseAnnualSurveyModal);
			return () => mobile.removeEventListener('back_button', onCloseAnnualSurveyModal);
		}
	});

	let navigationLink = '';
	$: {
		navigationLink = `https://mp0ai2g8g7t.typeform.com/to/hJTIDfgZ?utm_source=APP&utm_medium=${['de', 'fr', 'it'].includes($locale) ? `${$locale.toUpperCase()}` : 'EN'}&utm_campaign=Pop-up&typeform-source=statics.teams.cdn.office.net`;
		if ($user_data?.timezone.startsWith('America/')) {
			navigationLink =
				'https://mp0ai2g8g7t.typeform.com/to/YkzCT6qM?utm_source=APP&utm_medium=US&utm_campaign=Pop-up&typeform-source=statics.teams.cdn.office.net';
		}
	}
</script>

<Modal hideTitle {showModal} on:close={onCloseAnnualSurveyModal}>
	<Container slot="content" padding="0">
		<div class="d-flex flex-direction-column align-items-center">
			<img
				class="mb-l survey-image"
				src={`./images/survey_${['de', 'fr', 'it'].includes($locale) ? $locale : 'en'}.png`}
				alt="Annual Survey 2026"
			/>

			<Text class="text-center text-bold mb-l" element="h1">
				{$format('subtitle_one_annual_survey', {
					default: "It's feedback time!",
				})}
			</Text>
			<div class="main-text">
				<p class="mb-0 mt-0 sub-text text-center text-300 mb-l">
					{$format('subtitle_two_annual_survey', {
						default: 'Your opinion is valuable to us!',
					})}
					{$format('subtitle_three_annual_survey', {
						default: 'Fill out our quick survey and get 15% off.',
					})}
					{$format('subtitle_four_annual_survey', {
						default: 'Hurry! The survey is available until 08 February 2026.',
					})}
					{$format('subtitle_five_annual_survey', {
						default: 'The 15% discount code is valid until 31 May 2026.',
					})}
				</p>
			</div>
		</div>
		<div class="d-flex flex-direction-column align-items-center">
			<div class="mb-l bottom-content">
				<button class="button" on:click={() => navigateToUrl(navigationLink)}>
					{$format('button_take_annual_survey', {
						default: 'Take the survey',
					})}
				</button>
			</div>
			<Text class="cursor-pointer" on:click={onCloseAnnualSurveyModal}
				>{capFirstChar($format('button_maybe_later', { default: 'Maybe later' }))}</Text
			>
		</div>
	</Container>
</Modal>

<style>
	.survey-image {
		width: 100%;
		max-width: 528px;
		height: auto;
		object-fit: contain;
	}

	.main-text {
		max-width: 560px;
		opacity: 0.75;
	}

	.sub-text {
		font-size: 18px;
	}

	.bottom-content {
		width: 100%;
		max-width: 448px;
		box-sizing: border-box;
	}

	.button {
		width: 100%;
		box-sizing: border-box;
		height: 56px;
		font-size: 18px;
		background: #ffffff;
		border-radius: 45px;
		cursor: pointer;
	}
</style>
